module.exports = __webpack_public_path__ + "img/icon_sport_type_21.c70aa87f.png";